import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './Announcement.css';
import renderHTML from 'react-render-html';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import CorporateActOption from "../../CorporateActOption/CorporateActOption";
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function Announcement() {
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([])
    // const [groupValue, setGroupValue] = useState('Bseannouncement')
    const [groupValue, setGroupValue] = useState('BSE')
    const { BaseURL } = useContext(URLstateContext);
    // const [co_code, SetCo_code] = useState("476")
    const [dataGroup, setDataGroup] = useState([]);



    let getData, getDataGroup;
    let PageSize = 5;
    useEffect(() => {
        if (groupValue === "BSE") {
            // alert(groupValue)
            const getUrl = BaseURL + "Bseannouncement";
            fetch(`${getUrl}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //  console.log(getData, "getDataBSE")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "Nseannouncement";
            fetch(`${getUrl}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //  console.log(getData, "getDataNSE")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue])

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    CallTrackApi("Daily Announcements",window.location.href);


    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Daily Announcements</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Anno-loser-sc'>
                            <div className='Anno-header'>
                                <h2><span>Announcement</span></h2>
                            </div>
                            <CorporateActOption optionCorp="Daily Announcements" />
                            <div className='Anno-right'>
                             <div className='Anno-inner-select'>
                               
                                {/* aria-label="BSE NSE" */}
                                    <select aria-label="BSE NSE" onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="BSE">BSE</option>
                                        <option value="NSE">NSE</option>
                                    </select>
                                </div>
                            </div>
                            <hr className="Annohr"></hr>
                            <div className='Anno-table-table-responsive'>


                                <table className='table'>

                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ lname, memo }) => (
                                                <tr>
                                                    <div ><b>{lname}</b></div><br></br>
                                                    <div >{renderHTML(memo)}</div><br></br>


                                                </tr>
                                            ))}
                                    </tbody>
                                </table>


                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>


                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Announcement